const domain = 'https://htskfjsfsae.okxweb3.top/';  //你的域名
export default {
  publicUrl:domain
}